import React, { useContext } from 'react';
import { Navigate, useOutlet } from 'react-router-dom';
import { AuthContext } from '../navigation/TemporaryUserInfo';

export const LoginLayout = () => {
  const { user } = useContext(AuthContext);
  const outlet = useOutlet();

  if (user !== null) {
    return <Navigate to="/dashboard" replace />;
  }

  return <div>{outlet}</div>;
};
